/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const banquetCreateRequestItemsSchema = z.object({}).catchall(z.any());
